import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { PessoaWhitelabelModel } from 'model/api/gestao/pessoa/pessoa-whitelabel-model';
import { PessoaTaxaPostModel } from 'model/api/gestao/pessoa-taxa/pessoa-taxa-post-model';

export function usePostPessoaTaxa() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<PessoaWhitelabelModel>();

    const postPessoaTaxa = useCallback(
        (pessoaId: string, model: PessoaTaxaPostModel) =>
            invocarApi({
                method: 'POST',
                url: `/${VariaveisAmbiente.apiVersion}/pessoa/${pessoaId}/taxas`,
                data: model,
                enviarTokenUsuario: true
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        postPessoaTaxa,
    };
}